<template>
<div>
      <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel expand>
        <v-expansion-panel-header>{{$vuetify.lang.t('$vuetify.cui-user-information')}}<a class="cui-link" style="text-align :end " @click="goToIndex(0)"> Edit</a></v-expansion-panel-header>
         <v-expansion-panel-content  style="display:block">
        <div>
        <div class="cui-expandable__review-item">
            {{$vuetify.lang.t('$vuetify.cui-first-name')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.name.given}}</span>
        </div>
         <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-last-name' )}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.name.surname}}</span>
        </div>
        <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-email')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.email}}</span>
        </div>
        <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-country')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.addresses.country}}</span>
        </div>
        <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-street-address')}} 1:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.address1}}</span>
        </div>
       <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-street-address')}} 2:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.address2}}</span>
        </div>
         <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-city')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.addresses.city}}</span>
        </div>
         <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-state')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.addresses.state}}</span>
        </div>
         <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-postal')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.addresses.postal}}</span>
        </div>
        <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-telephone')}}:
              <span class="review-item__value" v-if="finalModel.userProfile">{{finalModel.userProfile.phones.number}}</span>
        </div>
        <div class="cui-expandable__review-item">
            <div v-for="(lang,index) in finalModel.languages" :key="index">
              <span class="review-item__value" v-if="finalModel.userProfile && (lang.language===finalModel.userProfile.language) ">
              {{$vuetify.lang.t('$vuetify.cui-language')}}:{{lang.title}}</span>
            </div>
        </div>
       <div class="cui-expandable__review-item">
            <div v-for="(timezone,index) in finalModel.timezones" :key="index">
              <span class="review-item__value" v-if="finalModel.userProfile && (timezone.id===finalModel.userProfile.timezone) ">
              {{$vuetify.lang.t('$vuetify.cui-timezone')}}:{{timezone.name}}</span>
            </div>
        </div>
        </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel >
        <v-expansion-panel-header aria-expanded="true">{{$vuetify.lang.t('$vuetify.cui-organization-information')}}<a style="text-align :end " @click="goToIndex(1)" class="cui-link"> Edit</a></v-expansion-panel-header>
        <v-expansion-panel-content>
            <span class="cui-expandable__review-item__field">{{$vuetify.lang.t('$vuetify.cui-org')}}</span> <span v-if="finalModel.organizationDetails !=null" class="review-item__value">{{finalModel.organizationDetails.name}}</span>
        </v-expansion-panel-content>
      </v-expansion-panel>
     <v-expansion-panel >
        <v-expansion-panel-header aria-expanded="true">{{$vuetify.lang.t('$vuetify.cui-sign-in-information')}}<a style="text-align :end " @click="goToIndex(2)" class="cui-link"> Edit</a></v-expansion-panel-header>
        <v-expansion-panel-content>
        <div>
      <div class="cui-expandable__review-item">
            {{$vuetify.lang.t('$vuetify.cui-user-id')}}:
              <span class="review-item__value" v-if="finalModel.userLogin">{{finalModel.userLogin.userId}}</span>
        </div>
         <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-password' )}}:
              <span class="review-item__value" v-if="finalModel.userLogin">{{finalModel.userLogin.password}}</span>
        </div>
        <div class="cui-expandable__review-item">
         <div v-for="(secQues,index) in finalModel.data.challengeQuestions1" :key="index">
              <span class="review-item__value" v-if="finalModel.userLogin !=undefined && secQues.id===finalModel.userLogin.securityQuestion1 ">
              {{$vuetify.lang.t('$vuetify.cui-challenge-question')}} 1: {{secQues.question[0].text}}</span>
         </div>
        </div>
        <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-challenge-answer')}}1:
              <span class="review-item__value" v-if="finalModel.userLogin">{{finalModel.userLogin.answer1}}</span>
        </div>
        <div class="cui-expandable__review-item">
          <div v-for="(secQues,index) in finalModel.data.challengeQuestions2" :key="index">
         <span class="review-item__value" v-if="finalModel.userLogin !=undefined && secQues.id===finalModel.userLogin.securityQuestion2 ">
              {{$vuetify.lang.t('$vuetify.cui-challenge-question')}} 2: {{secQues.question[0].text}}</span>
        </div>
        </div>
       <div class="cui-expandable__review-item">{{$vuetify.lang.t('$vuetify.cui-challenge-answer')}} 2:
              <span class="review-item__value" v-if="finalModel.userLogin">{{finalModel.userLogin.answer2}}</span>
        </div>
        </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
       <v-expansion-panel >
        <v-expansion-panel-header aria-expanded="true">{{$vuetify.lang.t('$vuetify.cui-application-selection')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
        <div v-if="finalModel.selectedApps !== undefined && finalModel.selectedApps.includes(true)">
            <ul v-for="(selected,indexApp) in finalModel.selectedApps" :key="indexApp">
                  <li style="list-style-type: disc" v-if="selected === true">{{finalModel.applications[indexApp].name[0].text}}</li>
            </ul>
        </div>
       <div v-else-if="finalModel.selectedAppsCount === 0">
             <span  class="cui-link" @click="goToIndex(3)">{{$vuetify.lang.t('$vuetify.no-applications-selected')}}</span>
        </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
    <div aria-expanded="true" class="v-expansion-panel v-expansion-panel--active v-item--active"><button type="button" class="v-expansion-panel-header v-expansion-panel-header--active" aria-expanded="true">Request Reason<div class="v-expansion-panel-header__icon"><i aria-hidden="true" class="v-icon notranslate material-icons theme--light">keyboard_arrow_down</i></div></button> <div class="v-expansion-panel-content" style=""><div class="v-expansion-panel-content__wrap"><div class="cui-applications__review-text-input"><!---->
              <div class="cui-applications__review-text-input">
                   <!-- <div class="cui-error" v-if="$v.requestReason.$error && !$v.requestReason.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div> -->
                  <!-- <input type="text" v-model="requestReason"  @blur="$v.requestReason.$touch()" class="cui-input"> -->
                  <input type="text" v-model="requestReason"  class="cui-input">
            </div></div></div></div></div>
</div>
</template>
<script>
// import { required } from 'vuelidate/lib/validators'
export default {
  components: {

  },
  data () {
    return {
      requestReason: '',
      panel: []
    }
  },
  validations: {
    form: []
  },
  props: ['finalModel'],
  methods: {
    validate () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    goToIndex (index) {
      this.$emit('on-click', index)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/registration/userReview.vue